//#region IMPORTS
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { fetchInstoreTemplatesAsync } from "./instoreTemplatesSlice";
import { useEffect } from "react";
import InstoreTemplatesContainer from "../../components/instoreTemplates/InstoreTemplatesContainer";
//#endregion

export default function InstoreTemplatesPage() {
  //#region SETUP
  const dispatch = useAppDispatch();
  const { instoreTemplates_Loaded } = useAppSelector(
    ({ instoreTemplates }) => instoreTemplates
  );
  //#endregion

  //#region LOGIC
  useEffect(() => {
    const fetchOnload = async () => {
      if (!instoreTemplates_Loaded) {
        await dispatch(fetchInstoreTemplatesAsync());
      }
    };
    fetchOnload();
  }, [instoreTemplates_Loaded, dispatch]);
  //#endregion

  return <InstoreTemplatesContainer />;
}
